
<script>
	import vue2Dropzone from "vue2-dropzone";
	import Multiselect from "vue-multiselect";
	import { bannerService } from "../../services";
	import { required } from "vuelidate/lib/validators";
	import config from "../../config";
	import { routes } from "../../config/api_routes";
	import { error_message } from "../../Helper/helper";
	import { success_message } from "../../Helper/helper";
	import DropzoneSingle from "../../components/widgets/dropzone-single";
	import DropzonePopup from "../../components/widgets/dropzone-popup";
	import DatePicker from "vue2-datepicker";
	import "vue2-datepicker/index.css";

	export default {
		components: {
			vueDropzone: vue2Dropzone,
			Multiselect,
			DropzoneSingle,
			DropzonePopup,
			DatePicker
		},
		data() {
			return {
				value: null,
				tmpBannerImage: "",
				url: null,
				config: config,
				search: "",
				errors: "",
				isLoading: false,
				resturant: [],
				selectedRestaurant: [],
				showTimeRangePanel: false,
				rangeSeparator: "-",
				typeform: {
					name: "",
					selectedRestaurant: "",
					image: null,
					status: true,
					// sort: '',
					banner_type : '1',
					// time_duration: [{banner_time_duration_id:'', start_time: '12:00 AM', end_time: '11:59 PM'}], // default values
					start_end_datetime : '',
				},
				banner_time_slots: config.time_slots_wise_data || [],
			};
		},
		validations: {
			typeform: {
				name: {
					required,
				},
				image: {
					required,
				},
				banner_type: {
					required
				},
				selectedRestaurant: {
					required,
				},
				start_end_datetime: {
					required,
				},
			},
		},
		methods: {
			onFileChange(e) {
				const file = e.target.files[0];
				this.url = URL.createObjectURL(file);
				this.typeform.image = file;
			},
			asyncFind(query) {
				this.isLoading = true;
				bannerService.getRestaurant(query).then((response) => {
					this.resturant = response.data.result;
					this.isLoading = false;
				});
			},
			clearAll() {
				this.selectedRestaurant = [];
			},
			bannerInIt() {
				this.$v.$touch();
				let isValid = true;

				this.banner_time_slots.forEach((day, dayIndex) => {
					day.time_slots.forEach((slot, slotIndex) => {
						if (slotIndex !== 0) {
							this.validateTimeSlots(dayIndex, slotIndex);
							if (Object.keys(slot.errors).length > 0) {
								isValid = false;
							}
						}
					});
				});

				if (this.$v.typeform.$invalid || !isValid) {
					return;
				} else {
					const fd = new FormData();
					fd.append("image", this.typeform.image);
					fd.append("name", this.typeform.name);
					fd.append("status", this.typeform.status ? 1 : 0);
					// fd.append("sort", this.typeform.sort ? this.typeform.sort : 0);
					fd.append("banner_type", this.typeform.banner_type);
					// fd.append("time_duration", JSON.stringify(this.typeform.time_duration));
					fd.append("start_end_datetime", this.typeform.start_end_datetime);
					fd.append("banner_time_slots", JSON.stringify(this.banner_time_slots));
					this.typeform.selectedRestaurant
					.map((item) => item.restaurant_id)
					.map((item, index) => {
						fd.append("restaurants[" + index + "]", item);
					});
					
					bannerService.addBanner(fd).then((response) => {
					if (response.data.code === 200) {
						// this.banner_time_slots = response?.data?.result?.banner_time_slots?.length > 0 ? response.data.result.banner_time_slots : [{banner_time_duration_id: '', start_time: '',end_time:''}];
						success_message(response.data.message);
						this.$router.push({ name: "banner-list" });
					} else {
						error_message(response.data.message);
					}
					});
				}
			},
			// AddDuration() {
			// 	// Add a new item to the array
			// 	if(this.typeform.time_duration.filter(t => (t.start_time == '' || t.end_time == '')).length == 0){
			// 		this.typeform.time_duration.push({banner_time_duration_id: '', start_time: '',end_time:''}); // add new
			// 		return true;
			// 	}
			// 	alert('Please select available slots first.')
			// },
			removeTimeSlot(id, slotIndex, dayIndex) {
				if(id)
				{
					bannerService.removeDuration(id).then((response) => {
					if(response.data.code === 200) 
					{
						this.getBannerById();
						success_message(response.data.message);
					} 
					else {
						error_message(response.data.message);
					}
					});
				}
				else
				{
					this.banner_time_slots[dayIndex].time_slots.splice(slotIndex, 1);
				}
			},
			// getDisabledEndTime(date,index){

			// 	var times = this.typeform.time_duration.filter((time,ind) => ind !== index && (time.start_time != '' && time.end_time != '') );
			// 	var rs = false
			// 	times.forEach(time => {
			// 		if(this.moment(date).isAfter(this.moment(time.start_time,'hh:mm A'))
			// 		&& this.moment(date).isSameOrBefore(this.moment(time.end_time,'hh:mm A'))){
			// 		rs = true;
			// 		}
			// 		if(this.typeform.time_duration[index].start_time !== '' && !rs){
			// 		if(!rs && this.moment(this.typeform.time_duration[index].start_time,'hh:mm A').isSameOrBefore(this.moment(time.start_time,'hh:mm A')) && this.moment(date).isAfter(this.moment(time.start_time,'hh:mm A'))){
			// 		rs = true;
			// 		}
			// 		}
			// 	});
			// 	if(this.typeform.time_duration[index].start_time !== '' && !rs){
			// 		if(this.moment(date).isSameOrBefore(this.moment(this.typeform.time_duration[index].start_time,'hh:mm A'))){
			// 		rs = true;
			// 		}
			// 	}
			// 	return rs;
			// },
			// getDisabledStartTime(date,index){

			// 	var times = this.typeform.time_duration.filter((time,ind) => ind !== index && (time.start_time != '' && time.end_time != '') );
			// 	var rs = false
			// 	times.forEach(time => {
			// 		if(this.moment(date).isSameOrAfter(this.moment(time.start_time,'hh:mm A'))
			// 		&& this.moment(date).isBefore(this.moment(time.end_time,'hh:mm A'))){
			// 		rs = true;
			// 		}
			// 		if(this.typeform.time_duration[index].end_time !== '' && !rs){
			// 		if(!rs && this.moment(this.typeform.time_duration[index].end_time,'hh:mm A').isSameOrAfter(this.moment(time.end_time,'hh:mm A')) && this.moment(date).isBefore(this.moment(time.end_time,'hh:mm A'))){
			// 			rs = true;
			// 		}
			// 		}
			// 	});
			// 	if(this.typeform.time_duration[index].end_time !== '' && !rs){
			// 		if(this.moment(date).isSameOrAfter(this.moment(this.typeform.time_duration[index].end_time,'hh:mm A'))){
			// 		rs = true;
			// 		}
			// 	}
			// 	return rs;
			// },
			toggleTimeRangePanel() {
				this.showTimeRangePanel = !this.showTimeRangePanel;
			},
			handleRangeClose() {
				this.showTimeRangePanel = false;
			},
			disabledBeforeTodayAndAfterAWeek(date) {
				return date < new Date(new Date().setHours(0, 0, 0, 0));
			},
			addTimeSlot(dayIndex) 
			{
				if (!this.banner_time_slots[dayIndex].time_slots.length) {
					alert("No existing time slots available for this day. Please add at least one.");
					return;
				}
				const hasValidTimeSlot = this.banner_time_slots[dayIndex].time_slots.some(t => t.start_time && t.end_time);

				if (!hasValidTimeSlot) {
					alert("No valid time slots available. Please set at least one before adding a new one.");
					return;
				}
				this.banner_time_slots[dayIndex].time_slots.push({
					start_time: "",
					end_time: "",
					errors: {}
				});
			},
			getDisabledTimeSlotEndTime(date, dayIndex, slotIndex) {
				let timeSlots = this.banner_time_slots[dayIndex].time_slots.filter((slot, i) => 
					i !== slotIndex && slot.start_time && slot.end_time
				);

				let isDisabled = timeSlots.some(slot => 
					this.moment(date, 'hh:mm A').isAfter(this.moment(slot.start_time, 'hh:mm A')) &&
					this.moment(date, 'hh:mm A').isSameOrBefore(this.moment(slot.end_time, 'hh:mm A'))
				);

				let currentSlot = this.banner_time_slots[dayIndex].time_slots[slotIndex];

				if (!isDisabled && currentSlot.start_time) {
					let startTime = this.moment(currentSlot.start_time, 'hh:mm A');

					isDisabled = timeSlots.some(slot => 
						startTime.isSameOrBefore(this.moment(slot.start_time, 'hh:mm A')) &&
						this.moment(date, 'hh:mm A').isAfter(this.moment(slot.start_time, 'hh:mm A'))
					);

					if (!isDisabled && this.moment(date, 'hh:mm A').isSameOrBefore(startTime)) {
						isDisabled = true;
					}
				}

				return isDisabled;
			},

			getDisabledTimeSlotStartTime(date, dayIndex, slotIndex) {
				let timeSlots = this.banner_time_slots[dayIndex].time_slots.filter((slot, i) => 
					i !== slotIndex && slot.start_time && slot.end_time
				);

				let isDisabled = timeSlots.some(slot => 
					this.moment(date, 'hh:mm A').isSameOrAfter(this.moment(slot.start_time, 'hh:mm A')) &&
					this.moment(date, 'hh:mm A').isBefore(this.moment(slot.end_time, 'hh:mm A'))
				);

				let currentSlot = this.banner_time_slots[dayIndex].time_slots[slotIndex];

				if (!isDisabled && currentSlot.end_time) {
					let endTime = this.moment(currentSlot.end_time, 'hh:mm A');

					isDisabled = timeSlots.some(slot => 
						endTime.isSameOrAfter(this.moment(slot.end_time, 'hh:mm A')) &&
						this.moment(date, 'hh:mm A').isBefore(this.moment(slot.end_time, 'hh:mm A'))
					);

					if (!isDisabled && this.moment(date, 'hh:mm A').isSameOrAfter(endTime)) {
						isDisabled = true;
					}
				}

				return isDisabled;
			},
			timeSlotData(updatedData, staticData) 
			{
				if (updatedData.length > 0) 
				{
					this.banner_time_slots = staticData.map(day => 
					{
						var matchedDiscount = updatedData.find(d => d.day === day.day);

						return {
							day: day.day,
							time_slots: matchedDiscount 
								? matchedDiscount.time_slots.map(slot => ({
									banner_time_duration_id: slot.banner_time_duration_id ?? null,
									start_time: slot.start_time ?? "",
									end_time: slot.end_time ?? "",
								}))
								: [{
									banner_time_duration_id: null,
									start_time: "",
									end_time: "",
								}]
						};
					});
				}
			},
			validateTimeSlots(dayIndex, slotIndex) 
			{
				let slot = this.banner_time_slots[dayIndex].time_slots[slotIndex];
				slot.errors = {}; // Clear errors before validation
				
				// Validate start time
				if (slotIndex !== 0 && !slot.start_time) {
					slot.errors.start_time = "Start time is required";
				}

				// Validate end time
				if (slotIndex !== 0 && !slot.end_time) {
					slot.errors.end_time = "End time is required";
				}
			},
		},
	};
</script>

<template>
	<b-form @submit.prevent="bannerInIt">
		<!-- Banner Info Start -->
		<div class="card">
			<div class="card-body">
				<h4 class="card-title">{{ trans.get('__JSON__.Banner Info') }}</h4>
				<p class="card-title-desc"></p>
				<div class="row">
					<div class="col-sm-6">
						<b-form-group id="input-group-1" :label="trans.get('__JSON__.Name')" label-for="name">
							<b-form-input
								id="name"
								name="name"
								v-model="$v.typeform.name.$model"
								type="text"
								:placeholder="trans.get('__JSON__.Banner Name Placeholder')"
								:class="{ 'is-invalid':  $v.typeform.name.$error }"
							></b-form-input>
							<div v-if=" $v.typeform.name.$error" class="invalid-feedback">
								<span
								v-if="!$v.typeform.name.required"
								>{{ trans.get('__JSON__.Banner Name Error') }}.</span>
							</div>
						</b-form-group>
					</div>

					<div class="col-sm-6">
						<div class="form-group">
							<label
							class="control-label"
							>{{ trans.get('__JSON__.Type') }}</label>
							<select
								class="custom-select"
								v-model="typeform.banner_type"
								id="banner_type"
								name="banner_type"
								:class="{ 'is-invalid': $v.typeform.banner_type.$error }"
							>
								<option value="1">{{ trans.get('__JSON__.Delivery - Takeaway') }}</option>
								<option value="2"> {{ trans.get('__JSON__.Dine In') }} </option>
							</select>
							<div v-if="$v.typeform.banner_type.$error" class="invalid-feedback cuisine-img">
								<span
									v-if="!$v.typeform.banner_type.required"
								>{{ trans.get('__JSON__.Banner Type Error') }}.</span>
							</div>
						</div>
					</div>

					<div class="col-sm-6">
						<b-form-group
						id="input-group-1"
						:label="trans.trans('__JSON__.Vendors',{ vendor: $auth.setting.restaurant_name })"
						label-for="banner_name"
						for="ajax"
						>
							<multiselect
								v-model="$v.typeform.selectedRestaurant.$model"
								id="ajax"
								label="name"
								track-by="name"
								:placeholder="trans.trans('__JSON__.Banner Vendor Search Placeholder',{ vendor: $auth.setting.restaurant_name })"
								open-direction="bottom"
								:options="resturant"
								:multiple="true"
								:searchable="true"
								:loading="isLoading"
								:internal-search="true"
								:clear-on-select="false"
								:close-on-select="false"
								:options-limit="5"
								:limit="3"
								:max-height="600"
								:show-no-results="false"
								:hide-selected="true"
								@search-change="asyncFind"
								:class="{ 'is-invalid': $v.typeform.selectedRestaurant.$error }"
							>
								<template slot="tag" slot-scope="{ option, remove }">
								<span class="custom__tag">
									<span>{{ option.name }}</span>
									<span class="custom__remove" @click="remove(option)">❌</span>
								</span>
								</template>
								<template slot="clear" slot-scope="props">
								<div
									class="multiselect__clear"
									v-if="selectedRestaurant.length"
									@mousedown.prevent.stop="clearAll(props.search)"
								></div>
								</template>
								<span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
							</multiselect>
							<div v-if=" $v.typeform.selectedRestaurant.$error" class="invalid-feedback">
								<span
								v-if="!$v.typeform.selectedRestaurant.required"
								>{{ trans.trans('__JSON__.Vendor Select Error',{ vendor: $auth.setting.restaurant_name }) }}.</span>
							</div>
						</b-form-group>
					</div>

					<div class="col-sm-6">
						<div class="form-group">
							<label class="control-label">{{ trans.get('__JSON__.Banner start and end date') }}</label>

							<date-picker
							v-model="$v.typeform.start_end_datetime.$model"
							:disabled-date="disabledBeforeTodayAndAfterAWeek"
							type="datetime"
							value-type="format"
							:rangeSeparator="rangeSeparator"
							placeholder="Select datetime range"
							range
							:show-time-panel="showTimeRangePanel"
							@close="handleRangeClose"
							:class="{ 'is-invalid': $v.typeform.start_end_datetime.$error }"
							>
								<template v-slot:footer>
									<button
									class="mx-btn mx-btn-text"
									@click="toggleTimeRangePanel"
									>{{ showTimeRangePanel ? 'select date' : 'select time' }}</button>
								</template>
							</date-picker>
							<div v-if="$v.typeform.start_end_datetime.$error" class="invalid-feedback">
								<span
									v-if="!$v.typeform.start_end_datetime.required"
								>{{ trans.get('__JSON__.Please select date') }}.</span>
							</div>
						</div>
					</div>

					<!-- <div class="col-md-6">
						<div class="form-group">
							<label>{{ trans.get('__JSON__.Banner Duration') }}</label>
							<div class="row pt-2" v-for="(item, index) in typeform.time_duration" :key="index">
								<input type="hidden" :name="'id[]'" :value="item.coupon_time_duration_id">
								<div class="col-sm-5">
									<date-picker
									v-model="item.start_time"
									:time-picker-options="{
										start: '00:00',
										step: '00:01',
										end: '23:59',
									}"
									format="hh:mm A"
									type="time"
									class="date-time"
									placeholder="hh:mm A"
									name="start_time[]"
									value-type="format"
						
									></date-picker>
								</div>
								<div class="col-sm-5">	
									<date-picker
									v-model="item.end_time"
									:time-picker-options="{
										start: '00:00',
										step: '00:01',
										end: '23:59',
									}"
									format="hh:mm A"
									type="time"
									class="date-time"
									placeholder="hh:mm A"
									name="end_time[]"
									value-type="format"
							
									></date-picker>
								</div>
								<div class="col-sm-2">
									<button class="btn btn-primary btn-sm btn-rounded" v-if="index == 0" @click.prevent="AddDuration"><i class="fas fa-plus"></i></button>
									<button class="btn btn-danger btn-sm btn-rounded" v-if="index > 0" @click.prevent="removeDuration(item.banner_time_duration_id, index)"><i class="fas fa-minus"></i></button>
								</div>
							</div>
						</div>
					</div> -->

					<!-- <div class="col-sm-6">
						<b-form-group id="input-group-1" :label="trans.get('__JSON__.Sort Order')" label-for="sort">
							<b-form-input
								id="sort"
								name="sort"
								v-model="typeform.sort"
								type="text"
								:placeholder="trans.get('__JSON__.Sort Order')"
							></b-form-input>
						</b-form-group>
					</div> -->
					
					<div class="col-sm-6 vendor-status">
						<b-form-group
						id="input-group-1"
						:label="trans.get('__JSON__.Status')"
						label-for="status"
						>
							<label class="switch">
								<input
								type="checkbox"
								id="togBtn"
								class="switch-on"
								checked
								v-model="typeform.status"
								/>
								<div class="slider round">
								<span class="on">{{ trans.get('__JSON__.Active') }}</span>
								<span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
								</div>
							</label>
						</b-form-group>
					</div>

					<div class="col-md-12">
						<div class="form-group mb-3">
							<label class="control-label">{{ trans.get('__JSON__.Day wise timeslot') }}</label>
						</div>
						<div class="row" :class="{'pt-3': index !== 0}" v-for="(dayData, index) in banner_time_slots" :key="index">
							<div class="col-md-1">
								<h6>{{ dayData.day }}</h6>
							</div>
							<div class="col-md-9">
								<div class="row" :class="{'pt-2': slotIndex !== 0}" v-for="(slot, slotIndex) in dayData.time_slots" :key="slotIndex">
									<input type="hidden" name="banner_time_duration_id[]" :value="slot.banner_time_duration_id" hidden>
									<div class="col-sm-2">
										<date-picker
											v-model="slot.start_time"
											:time-picker-options="{
											start: '00:00',
											step: '00:01',
											end: '23:59',
											}"
											format="hh:mm A"
											type="time"
											class="date-time"
											placeholder="hh:mm A"
											name="start_time[]"
											value-type="format"
											:disabled-time="function(date){return getDisabledTimeSlotStartTime(date, index, slotIndex)}"
											:class="{ 'is-invalid': slotIndex !== 0 && slot.errors && slot.errors.start_time }"
											></date-picker>
											<div v-if="slotIndex !== 0 && slot.errors && slot.errors.start_time"class="invalid-feedback">
												<span>{{ slot.errors.start_time }}</span>
											</div>
									</div>
									<div class="col-sm-2">	
										<date-picker
											v-model="slot.end_time"
											:time-picker-options="{
											start: '00:00',
											step: '00:01',
											end: '23:59',
											}"
											format="hh:mm A"
											type="time"
											class="date-time"
											placeholder="hh:mm A"
											name="end_time[]"
											value-type="format"
											:disabled-time="function(date){return getDisabledTimeSlotEndTime(date, index, slotIndex)}"
											:class="{ 'is-invalid': slotIndex !== 0 && slot.errors && slot.errors.end_time }"
											></date-picker>
											<div v-if="slotIndex !== 0 && slot.errors && slot.errors.end_time"class="invalid-feedback">
												<span>{{ slot.errors.end_time }}</span>
											</div>
									</div>
									<div class="col-sm-2">
										<button class="btn btn-primary btn-sm btn-rounded" v-if="slotIndex == 0" @click.prevent="addTimeSlot(index)">
											<i class="fas fa-plus"></i>
										</button>
										<button class="btn btn-danger btn-sm btn-rounded" v-if="slotIndex > 0" @click.prevent="removeTimeSlot(slot.banner_time_duration_id, slotIndex, index)">
											<i class="fas fa-minus"></i>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Banner Info End -->

		<!-- Banner Image Start -->
		<div class="card">
		<div class="card-body">
			<h4 class="card-title">{{ trans.get('__JSON__.Banner Image') }}</h4>
			<p class="card-title-desc"></p>

			<div class="row">
			<div class="col-sm-3">
				<dropzone-popup
				v-model="typeform.image"
				type="file"
				id="banner_image"
				name="image"
				acceptedFiles=".jpeg,.jpg,.png"
				:class="{ 'is-invalid': $v.typeform.image.$error }"
				/>
				<div v-if="$v.typeform.image.$error" class="invalid-feedback cuisine-img">
				<span
					v-if="!$v.typeform.image.required"
				>{{ trans.get('__JSON__.Banner Image Error') }}.</span>
				</div>
			</div>
			</div>

			<div class="row">
			<div class="col-sm-6">
				<button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Add Banner') }}</button>
				<b-button @click="$router.back()" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
			</div>
			</div>
		</div>
		</div>
		<!-- Banner Image End -->
	</b-form>
</template>

<style>
</style>